import { parse, format } from 'date-fns';
import { ru } from 'date-fns/locale';
import {
    computed, unref, Ref, ComputedRef,
   } from 'vue';
import { IReturnProductType } from '@ve/pages/hotel/types';
import touristGroupText from '@ve/services/entities-services/tourists/touristGroupText';

export default function (props: { firstProduct: ComputedRef<IReturnProductType | null> }) {
    const { firstProduct } = props;

    const getPhotos = computed(() => unref(firstProduct)?.room?.photos || []);

    const touristText = computed(() => `на ${touristGroupText(unref(firstProduct)?.touristGroup, true)}`);

    const startDateProduct = computed(() => parse(unref(firstProduct)?.startDate || '', 'yyyy-MM-dd', new Date()));

    const dateText = computed(() => `c ${format(unref(startDateProduct), 'd MMMM, EEEEEE', { locale: ru })}`);

    return {
        getPhotos,
        touristText,
        dateText,
    };
}